import { getStateWithOnlyOneLevel } from '../../utils/StateSelectorHelper';

// for common menu Mobile

// general state
function getMainState(state) {
  return getStateWithOnlyOneLevel(state, 'mainReducer');
}

export const getShowMobileMenu = (state) =>
  getMainState(state).get('showMobileMenu');
